import { Component, Input, OnInit } from '@angular/core';
import { UserStoreService } from 'src/app/services/user/user-store.service';

@Component({
  selector: 'app-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrls: ['./selectable-card.component.scss'],
})
export class SelectableCardComponent implements OnInit {
  @Input() label: string;
  @Input() type: string;
  @Input() groupValue: string;
  @Input() content: string;
  @Input() showLabel: true;
  //
  constructor(public userStore: UserStoreService) {}

  ngOnInit() {}

  isSelected() {
    const current = this.groupValue ? this.groupValue : this.haveCuc();
    return current ? current === this.label : false;
  }

  isBig() {
    return this.type === 'big';
  }

  haveCuc() {
    return this.userStore.activeCUC ? this.userStore.activeCUC.cuc : null
  }
}
